(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tagtail-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tagtail-lookbook')) {
  customElements.define('tagtail-lookbook', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.track = this.querySelector('[data-tt-track]');
      this.viewport = this.querySelector('.tt-story-gallery-viewport');
      this.slides = [...this.querySelectorAll('[data-tt-slide]')];
      if (!this.track || !this.viewport || this.slides.length < 2) return;
      this.cleanup = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.busy = false;
      this.hovered = false;
      this.focused = false;
      this.touching = false;
      this.inView = false;
      this.userPaused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.delay = Math.max(3000, Number(this.dataset.interval) || 4000);
      this.controls = this.querySelector('[data-tt-controls]');
      this.toggle = this.querySelector('[data-tt-toggle]');
      this.announcement = this.querySelector('[data-tt-announcement]');
      const listen = (node, event, action) => node.addEventListener(event, action, {signal:this.cleanup.signal});
      const copy = slide => {
        const clone = slide.cloneNode(true);
        clone.removeAttribute('data-tt-slide');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('data-tt-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        return clone;
      };
      this.track.prepend(...this.slides.slice(-2).map(copy));
      this.track.append(...this.slides.slice(0,2).map(copy));
      this.controls.hidden = false;
      this.classList.add('is-ready');
      this.viewport.scrollLeft = 0;
      listen(this.querySelector('[data-tt-prev]'), 'click', () => this.move(-1, true));
      listen(this.querySelector('[data-tt-next]'), 'click', () => this.move(1, true));
      listen(this.toggle, 'click', () => {
        this.userPaused = !this.userPaused;
        if (!this.userPaused) this.focused = false;
        this.schedule();
      });
      listen(this.viewport, 'keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1, true);
      });
      listen(this, 'pointerenter', event => { if(event.pointerType === 'mouse'){this.hovered = true;this.schedule();} });
      listen(this, 'pointerleave', event => { if(event.pointerType === 'mouse'){this.hovered = false;this.schedule();} });
      listen(this, 'focusin', () => {this.focused = true;this.schedule();});
      listen(this, 'focusout', event => {if(!this.contains(event.relatedTarget)){this.focused = false;this.schedule();}});
      listen(this.viewport, 'pointerdown', event => {
        if (event.pointerType === 'mouse' || !event.isPrimary) return;
        this.pointer = {x:event.clientX,y:event.clientY,id:event.pointerId};
        this.touching = true;
        this.schedule();
      });
      listen(window, 'pointerup', event => {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        const dx = event.clientX - this.pointer.x, dy = event.clientY - this.pointer.y;
        this.pointer = null;
        this.touching = false;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) this.move(dx < 0 ? 1 : -1, true);
        else this.schedule();
      });
      listen(window, 'pointercancel', () => {this.pointer = null;this.touching = false;this.schedule();});
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.motion, 'change', () => {if(this.motion.matches)this.userPaused = true;this.finish();this.schedule();});
      listen(this.track, 'transitionend', event => {if(event.target === this.track && event.propertyName === 'transform')this.finish();});
      listen(this, 'shopify:block:select', event => {
        const slide = event.target.closest('[data-tt-slide]');
        const index = this.slides.indexOf(slide);
        if (index < 0) return;
        this.userPaused = true;
        this.index = index;
        this.finish();
      });
      this.resizeObserver = new ResizeObserver(() => this.finish());
      this.resizeObserver.observe(this.viewport);
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.inView = entries.some(entry => entry.isIntersecting);
        this.schedule();
      }, {threshold:0});
      this.visibilityObserver.observe(this);
      this.position();
      this.schedule();
    }
    position() {
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const width = this.slides[0].getBoundingClientRect().width;
      this.track.style.transform = `translate3d(${-(this.index + 2) * (width + gap)}px,0,0)`;
      const current = (this.index + this.slides.length) % this.slides.length;
      const visible = this.viewport.clientWidth >= width * 1.8 ? 2 : 1;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== current && !(visible === 2 && i === (current + 1) % this.slides.length))));
      this.querySelector('[data-tt-counter]').textContent = `${current + 1} / ${this.slides.length}`;
    }
    move(delta, manual = false) {
      if (this.busy) return;
      if (manual) this.userPaused = true;
      clearTimeout(this.timer);
      this.index += delta;
      this.busy = true;
      this.classList.toggle('is-moving', !this.motion.matches);
      this.position();
      if (manual) this.announcement.textContent = this.slides[(this.index + this.slides.length) % this.slides.length].querySelector('figcaption').textContent;
      if (this.motion.matches) this.finish();
      else this.transitionTimer = setTimeout(() => this.finish(), 650);
      this.schedule();
    }
    finish() {
      clearTimeout(this.transitionTimer);
      this.index = (this.index + this.slides.length) % this.slides.length;
      this.busy = false;
      this.classList.remove('is-moving');
      this.position();
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      this.toggle.querySelector('[data-tt-toggle-label]').textContent = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
      this.toggle.querySelector('[data-tt-toggle-icon]').textContent = this.userPaused ? '▶' : 'Ⅱ';
      const playing = !this.userPaused && !this.hovered && !this.focused && !this.touching && !document.hidden && this.inView && !this.busy;
      this.dataset.playing = String(playing);
      if (playing) this.timer = setTimeout(() => this.move(1), this.delay);
    }
    disconnectedCallback() {
      if (!this.cleanup) return;
      this.cleanup.abort();
      this.cleanup = null;
      clearTimeout(this.timer);
      clearTimeout(this.transitionTimer);
      this.resizeObserver.disconnect();
      this.visibilityObserver.disconnect();
      this.track.querySelectorAll('[data-tt-clone]').forEach(node => node.remove());
      this.slides.forEach(node => node.removeAttribute('aria-hidden'));
      this.classList.remove('is-ready', 'is-moving');
      this.track.style.transform = '';
      this.controls.hidden = true;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
